import { defineMessages } from 'react-intl';

/**
 * The copy of a spent Free AI budget (owner decisions 2026-10-08): the LiteLLM key of Free and
 * trial workspaces has no budget left this month. Paid workspaces never see it. The failed asset
 * or reel (`AI_BUDGET_EXHAUSTED`) and the 429 `M24_AI_BUDGET_FREE_EXHAUSTED` say it, with an upgrade.
 */
export const aiBudgetMessages = defineMessages({
  failSentence: {
    id: 'app.sml.promote.aiBudget.fail',
    defaultMessage: 'AI is busy this month. Upgrade for priority access.',
  },
  failShort: { id: 'app.sml.promote.aiBudget.failShort', defaultMessage: 'AI busy this month' },
  upgrade: { id: 'app.sml.promote.aiBudget.upgrade', defaultMessage: 'Upgrade' },
});
